import React, {FunctionComponent, useContext, Fragment} from 'react';
import {observer} from "mobx-react";
import TranslatedText from "../../../ui/TranslatedText/TranslatedText";
import TranslatedNode from "../../../ui/TranslatedNode/TranslatedNode";
import {Typography} from "@material-ui/core";
import UITranslations from "../../../../store/uiTranslations";
import {Context} from "../../../../store/context";
import {UrlBuilder} from "../../../../utils/urlBuilder";
import Link from "@material-ui/core/Link";
import {Routes} from "../../../../routes";
import {ChannelParam} from "../../../../store/QueryParamsStore/QueryParamsEnums";
import TranslatedNodeDestination from '../../../ui/TranslatedNode/TranslatedNodeDestination';

interface IProceedToItem {
    parkTheCar:boolean;
}

const ProceedToItem:FunctionComponent<IProceedToItem> = ({parkTheCar}) => {
    const ui = UITranslations.GettingToPage.Wizard.Entrance;

    const {gettingToPageStore, languagesStore} = useContext(Context);
    const {settings} = gettingToPageStore;

    if (!settings)
        return null;

    const entranceId = parkTheCar ? settings.preferredEntranceId : settings.pedestrianEntranceId;
    const destinationId = settings.directAccess ? settings.destinationId : settings.firstReportId;
    const photoRouteLink = UrlBuilder.Relative(Routes.PhotoRoute)
        .searchParams({
            buildingId: settings.buildingId,
            nodeFrom: entranceId,
            nodeTo: destinationId,
            routeLang: languagesStore.currentIETF,
            channel: ChannelParam.AppIntScreen
        }).href;

    return <Fragment>
        <Typography>
            <TranslatedText source={ui.Proceed}/>
            {' '}
            <Link href={photoRouteLink} underline="always">
                <TranslatedText source={ui.To}/>
                {' '}
                <strong><TranslatedNodeDestination id={destinationId as any}/></strong>
            </Link>
        </Typography>
        {
            !settings.directAccess &&
            <Typography>
                <TranslatedText source={ui.RegisterFirst}/>
            </Typography>
        }
    </Fragment>
}

export default observer(ProceedToItem);
